import { render, staticRenderFns } from "./ReservedPage.vue?vue&type=template&id=37653a82&scoped=true&lang=pug"
import script from "./ReservedPage.vue?vue&type=script&lang=js"
export * from "./ReservedPage.vue?vue&type=script&lang=js"
import style0 from "./ReservedPage.vue?vue&type=style&index=0&id=37653a82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37653a82",
  null
  
)

export default component.exports